import { PagePaths } from "../../../../types";

const BlogTypes = {
  bitcoin: "Bitcoin & Crypto",
  coinmiles: "Coinmiles",
  perks: "Perks",
  bitcoinFr: "Bitcoin et crypto",
  coinmilesFr: "Coinmiles",
  perksFr: "Avantages",
}

// TODO: Add blog data for Parachute Partners
export const blogData = 
  {
    [PagePaths.home]: [
        {
          image: "howToEarn",
          date: "2025-09-09",
          blogTypeText: BlogTypes.perks,
          blogTypeTextFr: BlogTypes.perksFr,
          title: "How to Earn Rewards with Parachute",
          titleFr: "Comment gagner des récompenses avec Parachute",
          description: "Learn how your employees can earn their first rewards.",
          descriptionFr: "Découvrez comment vos employés peuvent gagner leurs premières récompenses.",
          blogUrl: "https://www.parachutebenefits.com/post/how-to-use-your-parachute-perks",
        },
      ],
    [PagePaths.cashbackRewards]: [
        {
          image: "boostActivatePerks",
          date: "2022-05-09",
          blogTypeText: BlogTypes.coinmiles,
          blogTypeTextFr: BlogTypes.coinmilesFr,
          title: "Boosts: Activate your Benefits",
          titleFr: "Boosts : activez vos avantages",
          description: "Introducing Boosts, your best tool to increase adoption.",
          descriptionFr: "Découvrez Boosts, votre meilleur outil pour augmenter l'adoption.",
          blogUrl: "https://coinmiles.io/blog/activate-with-boosts",
        },
      ]  
    }
